import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import useMediaQuery from '@mui/material/useMediaQuery';

export type Breakpoints = 'desktop' | 'tablet' | 'mobile' | null;

export const useBreakpoints = (): Breakpoints => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.mediaQueries.mobile);
  const isTablet = useMediaQuery(theme.mediaQueries.tablet);
  const isDesktop = useMediaQuery(theme.mediaQueries.desktop);

  const breakpoint = useMemo(() => {
    if (isDesktop) return 'desktop';
    if (isTablet) return 'tablet';
    if (isMobile) return 'mobile';

    return null;
  }, [isMobile, isTablet, isDesktop]);

  return breakpoint;
};
